import { useState } from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Textarea } from "@/components/ui/textarea";
import { api, formatApiError, fmtDateTime } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export function CancelInvoiceDialog({ open, onOpenChange, invoice, onDone }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const authAt = invoice?.authorized_at || invoice?.created_at || "";
  const hours = authAt ? Math.floor((Date.now() - new Date(authAt).getTime()) / 3600000) : 0;
  const beyond = (invoice?.kind === "nfe" || invoice?.kind === "nfce") && hours > 24;
  const ok = reason.trim().length >= 15 && !busy && !beyond;
  const submit = async () => {
    setBusy(true);
    try { await api.post(`/fiscal/invoices/${invoice.id}/cancel`, { reason: reason.trim() });
      toast.success("Cancelamento solicitado"); onOpenChange(false); setReason(""); onDone?.(); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="cancel-invoice-dialog" className="bg-zinc-950 border border-zinc-800 text-zinc-100 max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display uppercase">Cancelar nota {invoice?.kind?.toUpperCase()}</AlertDialogTitle>
          <AlertDialogDescription className="text-zinc-400">
            Informe o motivo do cancelamento (mínimo 15 caracteres, regra da Sefaz). A nota {authAt ? `foi emitida em ${fmtDateTime(authAt)}` : "está autorizada"}.
          </AlertDialogDescription>
        </AlertDialogHeader>
        {beyond && (
          <div data-testid="cancel-warn" className="rounded-md border border-red-800/70 bg-red-950/40 p-3 text-xs text-red-200">
            O prazo legal para cancelamento ({invoice?.kind === "nfce" ? "NFC-e" : "NF-e"}: 24h) já passou, então não dá mais para cancelar por aqui. Fale com o contador sobre CC-e ou nota de devolução.
          </div>
        )}
        <Textarea data-testid="cancel-reason" rows={4} value={reason} onChange={(e) => setReason(e.target.value)}
                  placeholder="Ex.: Nota emitida com valor errado — refaremos com os valores corretos" className="bg-zinc-900 border-zinc-800" />
        <div className={`text-[11px] ${reason.trim().length < 15 ? "text-amber-300" : "text-zinc-500"}`}>{reason.trim().length}/15 caracteres</div>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-zinc-900 border-zinc-800 text-zinc-200">Voltar</AlertDialogCancel>
          <AlertDialogAction data-testid="cancel-confirm" disabled={!ok} onClick={submit} className="bg-red-600 hover:bg-red-500 text-white">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Confirmar cancelamento"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
